import { HomeFooter } from "homepage/homeFooter";
import { Header } from "homepage/homeHeader";
import React, { useState, useEffect } from "react";
import api from "services/api";
import "./termsCondition.css";

export const TermsConditions = () => {
  return (
    <div className="home-page">
      <Header />
      <section className="network">
        <div className="container network-block">
          <div className="row">
            <div className="col-md-12 mb-5">
              <div className="network-content">
                <h1 className="main-title lh-70 text-center">
                  <span className="text-gradient terms-main-title">
                    Terms of Use
                  </span>
                  <br />
                </h1>
                <div className="title-slogan px-5 terms-content">
                  <p className="terms-body-text">
                    Welcome to Zenosure Digital Private Limited! Our platform
                    provides exclusive cash backs and discounts on medical
                    services, prescriptions, and other healthcare-related
                    privileges. These benefits are available when you purchase
                    certain products or services from our Affiliate Partners,
                    which include hospitals, pharmacies, laboratories, fitness
                    centres, and more. You'll need a yearly subscription to
                    avail of these benefits, with different plans offering
                    various prices and features. Throughout this document, terms
                    such as "we," "our," or "us" refer to Zenosure Digital
                    Private Limited as a single entity, while "you" refers to
                    users of our website or app.
                  </p>

                  <p className="terms-body-text">
                    By accessing or using this website, you automatically agree
                    to the terms & conditions set forth here and represent that
                    you have read and understood them. If you do not accept all
                    these terms and conditions, you are not authorised to use
                    this website. These terms are subject to change, and your
                    continued use of the website signifies your acceptance of
                    any modifications.
                  </p>

                  <h5 className="terms-section-heading">
                    Usage of the Website
                  </h5>

                  <p className="terms-body-text">
                    While using this website, you agree to the following
                    conditions:
                  </p>
                  <ul className="terms-list">
                    <li className="terms-list-item">
                      All information you provide on this website is accurate
                      and complete. You are responsible for keeping it current.
                    </li>
                    <li className="terms-list-item">
                      You are responsible for the security of your account
                      details and login credentials.
                    </li>
                    <li className="terms-list-item">
                      You must be 18 years or older to register on Zenosure or
                      contribute to the site.
                    </li>
                    <li className="terms-list-item">
                      You have the legal authority to enter this agreement and
                      to use the website in accordance with all terms and
                      conditions.
                    </li>
                    <li className="terms-list-item">
                      You are not authorised to use, replicate, or distribute
                      content on the website for personal or commercial purposes
                      without permission.
                    </li>
                    <li className="terms-list-item">
                      We retain the right to deny access to this website and our
                      services at any time for any reason, including violations
                      of this agreement.
                    </li>
                  </ul>

                  <h5 className="terms-section-heading">Account Information</h5>

                  <p className="terms-body-text">
                    Zenosure's services are available exclusively to residents
                    of India. We permit only one account per individual, and to
                    maintain a secure and seamless user experience, we do not
                    allow changes to personal details such as name and email
                    address after registration. Please ensure that you have
                    access to the email address you provide during registration,
                    as it is essential for all communications with Zenosure.
                  </p>

                  <h5 className="terms-section-heading">
                    Cashback and Redemption Policy
                  </h5>

                  <p className="terms-body-text">
                    As a Zenosure member, you may earn cash backs or discounts
                    on transactions with our Affiliate Partners. Please note
                    that cash backs are credited only after verification by the
                    respective partner. Transactions must be genuine and
                    completed successfully; otherwise, they will not qualify for
                    cashback.
                  </p>

                  <p className="terms-body-text">
                    Upon meeting these conditions, cashback will be credited to
                    the account owner's valid bank account within the next
                    calendar month following the transaction or claim. It is the
                    member's responsibility to provide valid banking details.
                  </p>

                  <h5 className="terms-subsection-heading">
                    Policy on Discrepancies:
                  </h5>
                  <ul className="terms-list">
                    <li className="terms-list-item">
                      <strong>Rejected Cashback:</strong> Cashbacks not
                      qualifying with a partner's terms may be marked as
                      invalid. Zenosure is not liable for these instances. Refer
                      to our FAQs for partner-specific policies.
                    </li>
                    <li className="terms-list-item">
                      <strong>Missing Cashback:</strong> If you have made a
                      genuine transaction but do not receive a cashback, please
                      contact us at support@zenosure.com within 30 calendar days
                      of the transaction date, as all claims are time-bound and
                      may be rejected if not made within the stipulated time.
                      Please note that if the affiliate partner rejects your
                      claim for any valid reason, Zenosure will not be able to
                      provide the cashback.
                    </li>
                    <li className="terms-list-item">
                      <strong>Erroneous Cashback Transfer:</strong> Zenosure
                      reserves the right to rectify any cashback errors due to
                      system or clerical issues and may contact you to return
                      any incorrect amounts.
                    </li>
                  </ul>

                  <p className="terms-body-text">
                    Zenosure is not liable for claims denied by affiliate
                    partners due to issues such as policy violations,
                    transaction errors, or other grounds for rejection.
                    Additionally, Zenosure reserves the right to reject claims
                    if they do not meet the specified eligibility criteria or
                    are not submitted within the specified timeframe.
                  </p>

                  <h5 className="terms-section-heading">Refund Policy</h5>

                  <p className="terms-body-text">
                    We value transparency and fairness in our services. Please
                    read our refund policy carefully:
                  </p>
                  <ul className="terms-list">
                    <li className="terms-list-item">
                      <strong>No Refund After Use:</strong> Once you have used
                      your Zenosure membership to avail of any cashback,
                      discount, or benefit from our Affiliate Partners, you will
                      not be eligible for any refund of the membership
                      fee—whether partial or full.
                    </li>
                    <li className="terms-list-item">
                      <strong>Refund Eligibility:</strong> If you have not used
                      your Zenosure membership in any way, you may request a
                      refund within 7 (seven) calendar days from the date of
                      purchase. Requests received after this period will not be
                      entertained.
                    </li>
                    <li className="terms-list-item">
                      <strong>Refund Procedure:</strong> To initiate a refund
                      request, you must email support@zenosure.com with your
                      registered details and a statement declaring that no
                      services or benefits have been used. Upon verification,
                      eligible refunds will be processed within 10 business days
                      via the original method of payment.
                    </li>
                    <li className="terms-list-item">
                      <strong>Non-Transferability:</strong> Memberships are
                      non-transferable and non-exchangeable. Refunds will only
                      be processed to the original subscriber.
                    </li>
                  </ul>

                  <p className="terms-body-text">
                    This policy complies with the Consumer Protection Act, 2019,
                    and is aligned with relevant provisions under Karnataka
                    consumer welfare norms for digital service platforms. For
                    any disputes, jurisdiction will lie with the appropriate
                    courts in Bangalore, Karnataka.
                  </p>

                  <h5 className="terms-section-heading">
                    Termination of Account
                  </h5>

                  <p className="terms-body-text">
                    Zenosure reserves the right to deactivate or terminate any
                    user's account in cases of fraud, abuse, or unfair activity.
                    Accounts inactive for 12 months may also be deemed inactive
                    and subject to termination. Additionally, Zenosure does not
                    permit accounts for non-personal or commercial purposes, and
                    such accounts will be terminated with any cashback
                    forfeited.
                  </p>

                  <h5 className="terms-section-heading">Privacy Policy</h5>

                  <p className="terms-body-text">
                    We prioritise the security and privacy of your data. Any
                    personal information you provide to us will be handled in
                    accordance with our Privacy Policy. Zenosure will only use
                    your email or phone number for communication purposes
                    related to your account and our services.
                  </p>

                  <h5 className="terms-section-heading">Products/Services</h5>

                  <p className="terms-body-text">
                    Zenosure partners with various Affiliate Partners to offer
                    exclusive discounts and cashbacks on specific healthcare
                    products and services. Product descriptions and pricing may
                    change without prior notice. While Zenosure aims to ensure
                    high-quality service, any third-party products or services
                    accessed through Affiliate Partners are solely the
                    responsibility of the respective provider. Zenosure is not
                    liable for the quality or outcome of these services.
                  </p>

                  <h5 className="terms-section-heading">Third-Party Links</h5>

                  <p className="terms-body-text">
                    This website may contain links to third-party websites,
                    which may charge fees. Zenosure does not warrant or have
                    liability for any third-party materials, products, or
                    services. We recommend carefully reviewing their terms and
                    conditions before use, as Zenosure is not responsible for
                    any issues arising from third-party transactions.
                  </p>

                  <h5 className="terms-section-heading">
                    Promotional Communications
                  </h5>

                  <p className="terms-body-text">
                    We may occasionally contact users via email, SMS, or other
                    channels regarding special offers, discounts, or news about
                    our services. You may opt out of these communications by
                    following the 'unsubscribe' instructions provided in each
                    message. However, withdrawing consent for promotional
                    messages will not impact our ability to contact you for
                    essential account notifications.
                  </p>

                  <h5 className="terms-section-heading">Indemnification</h5>

                  <p className="terms-body-text">
                    You agree to indemnify and defend Zenosure Digital Private
                    Limited and our affiliates, partners, and employees from any
                    claims or demands arising from your breach of these terms or
                    any violation of laws or third-party rights.
                  </p>

                  <h5 className="terms-section-heading">Governing Law</h5>

                  <p className="terms-body-text">
                    These Terms of Use are governed by the laws of India. Any
                    dispute will be resolved through binding arbitration per the
                    Indian Arbitration Act 1996. Proceedings will take place in
                    Bangalore, India, with judgement entered in any court of
                    jurisdiction.
                  </p>

                  <h5 className="terms-section-heading">Addenda</h5>

                  <p className="terms-body-text">
                    Zenosure reserves the right to amend these terms at any
                    time. Updates will be posted on the website or sent to
                    registered members. Your continued use of the website
                    constitutes acceptance of the updated terms.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <HomeFooter />
    </div>
  );
};
